var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_87_231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 73,
    height: 74
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9378 21.25C19.8498 21.25 23.0212 18.0787 23.0212 14.1667C23.0212 10.2547 19.8498 7.08337 15.9378 7.08337C12.0258 7.08337 8.85449 10.2547 8.85449 14.1667C8.85449 18.0787 12.0258 21.25 15.9378 21.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85449 31.875H23.0212V76.1458H8.85449V31.875ZM37.1878 48.6979V76.1458H49.5837V51.3542C49.5837 46.9271 52.2399 43.3854 56.667 43.3854C61.0941 43.3854 63.7503 47.8125 63.7503 51.3542V76.1458H76.1462V48.6979C76.1462 43.3854 69.9482 31.875 56.667 31.875C43.3857 31.875 37.1878 43.3854 37.1878 48.6979Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_87_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H85V85H0V0Z",
    fill: "#3ECF7A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinHover);
export default __webpack_public_path__ + "static/media/linkedin_hover.52b063e6be3a8f5bafeb2ae98c0a140a.svg";
export { ForwardRef as ReactComponent };